<template>
  <component
    :is="icon"
    v-if="name"
    :name="name"
    class="lucide-icon"
    :class="[`icon-${name}`]"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { icons } from "./lucideIcons";
import type { IconName } from "./lucideIcons";

const props = defineProps<{
  name: IconName;
}>();

const icon = computed(() => {
  if (!(props.name in icons)) {
    console.error(`Icon ${props.name} does not exist!`, icons);
  }
  return icons[props.name];
});
</script>

<style lang="scss">
.lucide-icon {
  height: 1em;
  width: 1em;
  margin-top: -1px;
  margin-bottom: -1px;

  display: inline-block;
  overflow: visible;
}
</style>
